const locked_sections_fields = [
  //cannot disable: 'title',
  //cannot disable: 'valid_for_days',

  'sections',
  'highlight_rows',
  'business_video_link',
  'pdf_systems_to_include',
  'pdf_payment_options_to_include',
  'exhibit_content',
  'show_product_types',
  'featured_product_types',

  'cover_image_format',

  'heading_cover',
  'proposal_image_file_contents',
  'co_branding_logo_file_contents',
  'bespoke_template_file_contents',
  'override_logo_file_contents',
  'letter_page_content',
  'header_column_1',
  'header_column_2',
  'header_column_3',

  'footer_column_1',
  'footer_column_2',
  'footer_column_3',
  'footer_column_4',

  'footer_column_left',

  'about_us_content',
  'next_steps_content',
  'quotation_custom_content',
  'content_block_1',

  'content_block_2',

  'content_block_3',

  'heading_recommended_system_option',
  'heading_system_hardware',
  'heading_system_performance',
  'heading_electricity_bill_savings',
  'heading_how_your_system_works',
  'heading_daily_energy_flows',
  'heading_payment_option',
  'heading_net_financial_impact',
  'heading_environmental_benefits',
  'heading_case_studies',
  'heading_next_steps',

  'disclaimer_system_hardware_components',
  'disclaimer_system_performance_new',
  'disclaimer_environmental_benefits',
  'disclaimer_system_performance',
  'disclaimer_daily_energy_flows',
  'disclaimer_system_price',
  'disclaimer_financial_impact',
  'disclaimer_payment_option_cash',
  'disclaimer_payment_option_loan',
  'disclaimer_payment_option_ppa',
  'disclaimer_payment_option_regular_payment',
  'disclaimer_payment_option_lease',
  'disclaimer_payment_option_prepaid_lease',
  'disclaimer_payment_option_prepaid_ppa',
]

const getLockedSectionsChoices = () => {
  return locked_sections_fields.map((lockedSectionFieldName) => {
    const _field = PROPOSAL_TEMPLATE_INPUTS_FIELDS.filter((f) => f.fieldName === lockedSectionFieldName)[0]
    if (_field && _field.fieldLabel) {
      return { label: _field.fieldLabel, defaultValue: false, id: lockedSectionFieldName }
    } else {
      return { label: lockedSectionFieldName, defaultValue: false, id: lockedSectionFieldName }
    }
  })
}

const DISCLAIMER_FIELDS = [
  { type: 'h2', title: 'Disclaimers' },
  {
    fieldName: 'disclaimer_system_hardware_components',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_and_system_without_project_specific_terms',
    fieldLabel: 'System Hardware Components',
    allowUploadImage: true,
  },
  {
    fieldName: 'disclaimer_system_performance_new',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_and_system_without_project_specific_terms',
    fieldLabel: 'System Performance',
    allowUploadImage: true,
  },
  {
    fieldName: 'disclaimer_environmental_benefits',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_and_system_without_project_specific_terms',
    fieldLabel: 'Environmental Benefits',
    allowUploadImage: true,
  },
  {
    fieldName: 'disclaimer_system_performance',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_and_system_without_project_specific_terms',
    fieldLabel: 'Bill Savings',
    allowUploadImage: true,
  },
  {
    fieldName: 'disclaimer_daily_energy_flows',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_and_system_without_project_specific_terms',
    fieldLabel: 'Daily Energy Flows',
    allowUploadImage: true,
  },
  {
    fieldName: 'disclaimer_system_price',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_and_system_without_project_specific_terms',
    fieldLabel: 'System Quotation',
    allowUploadImage: true,
  },
  {
    fieldName: 'disclaimer_financial_impact',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_and_system_without_project_specific_terms',
    fieldLabel: 'Financial Impact',
    allowUploadImage: true,
  },
  {
    fieldName: 'disclaimer_payment_option_cash',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_and_system_without_project_specific_terms',
    fieldLabel: 'Financial Impact - Cash',
    allowUploadImage: true,
  },
  {
    fieldName: 'disclaimer_payment_option_loan',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_and_system_without_project_specific_terms',
    fieldLabel: 'Financial Impact - Loan',
    allowUploadImage: true,
  },
  {
    fieldName: 'disclaimer_payment_option_ppa',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_and_system_without_project_specific_terms',
    fieldLabel: 'Financial Impact - PPA',
    allowUploadImage: true,
  },
  {
    fieldName: 'disclaimer_payment_option_regular_payment',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_and_system_without_project_specific_terms',
    fieldLabel: 'Financial Impact - Regular Payment',
    allowUploadImage: true,
  },
  {
    fieldName: 'disclaimer_payment_option_lease',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_and_system_without_project_specific_terms',
    fieldLabel: 'Financial Impact - Lease',
    allowUploadImage: true,
  },
  {
    fieldName: 'disclaimer_payment_option_prepaid_lease',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_and_system_without_project_specific_terms',
    fieldLabel: 'Financial Impact - Prepaid Lease',
    allowUploadImage: true,
  },
  {
    fieldName: 'disclaimer_payment_option_prepaid_ppa',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_and_system_without_project_specific_terms',
    fieldLabel: 'Financial Impact - Prepaid PPA',
    allowUploadImage: true,
  },
]

/** Featured figure ids for End of Energy (EOE): environmental, electricity utility, and electricity financial metrics. */
export const EOE_KEYS = [
  // Environmental
  'eoe_co2_tons',
  'eoe_car_km',
  'eoe_trees_planted',
  'eoe_flights',
  // Utility bill & savings (electricity account only)
  'electricity_utility_savings_total',
  'electricity_utility_bill_savings_year_0',
  'electricity_utility_savings_per_bill_year_0',
  'electricity_net_savings_year_0',
  'electricity_utility_bill_before_solar_year_0',
  'electricity_utility_bill_after_solar_year_0',
  'electricity_utility_bill_lifetime_before_solar',
  'electricity_utility_bill_lifetime_after_solar',
  'electricity_average_monthly_old_bill',
  'electricity_average_monthly_new_bill_year_1',
  // Financial metrics (electricity)
  'electricity_net_present_value',
  'electricity_payback',
  'electricity_discounted_payback_period',
  'electricity_total_return_on_investment',
  'electricity_internal_rate_of_return',
] as const

export const FEATURE_FIGURES_FIELDS = [
  { type: 'h2', title: 'Featured Figures' },
  {
    fieldName: 'highlight_rows',
    fieldLabel: 'Featured Figures',
    type: 'FeatureFiguresSelector',
    choices: [
      // Technical Metrics
      { id: 'kw_stc', name: 'PV System Size' },
      { id: 'kwp_stc', name: 'PV System Size (kWp)' },
      { id: 'battery_total_kwh', name: 'Battery Size' },
      { id: 'daily_solar_generation', name: 'Daily Solar Generation (Year 1)' },
      { id: 'annual_solar_generation', name: 'Annual Solar Generation (Year 1)' },
      { id: 'consumption_offset_percentage', name: 'Consumption Offset (%)' },
      { id: 'energy_from_solar', name: 'Energy From Solar (%)' },
      { id: 'grid_independence', name: 'Grid Independence (%)' },
      { id: 'self_consumption', name: 'Self Consumption (%)' },
      { id: 'capacity_factor', name: 'Capacity Factor (%)' },
      { id: 'performance_ratio', name: 'Performance Ratio (%)' },
      { id: 'system_lifetime', name: 'System Lifetime' },
      { id: 'annual_energy_consumption', name: 'Annual Electricity Usage' },
      { id: 'annual_energy_import_grid', name: 'Annual Electricity Drawn from Grid' },
      { id: 'emissions_offset_percentage', name: '% Of CO₂, SOₓ & NOₓ per year' },
      { id: 'co2_tons', name: 'Tons of CO₂ reduced per year' },
      { id: 'eoe_co2_tons', name: 'Tons of CO₂ reduced per year (all energy)' },
      { id: 'car_km', name: 'Car distance avoided (lifetime)' },
      { id: 'eoe_car_km', name: 'Car distance avoided (lifetime, all energy)' },
      { id: 'trees_planted', name: 'Trees planted' },
      { id: 'eoe_trees_planted', name: 'Trees planted (all energy)' },
      { id: 'flights', name: 'Long haul flights avoided' },
      { id: 'eoe_flights', name: 'Long haul flights avoided (all energy)' },

      // Utility Bill & Savings
      { id: 'utility_savings_total', name: 'Utility Savings (Lifetime)' },
      { id: 'utility_bill_savings_year_0', name: 'Utility Savings (Year 1)' },
      { id: 'utility_savings_per_bill_year_0', name: 'Utility Savings Per Bill' },
      { id: 'net_savings_year_0', name: 'First Year Savings' },
      { id: 'total_energy_cost_after_solar', name: 'Annual Energy Cost After Install' },
      { id: 'solar_cost_per_kwh_year_0', name: 'Solar Cost Per kWh' },
      { id: 'average_utility_rate_before_solar_year_0', name: 'Average Utility Rate Before Install' },
      { id: 'utility_bill_before_solar_year_0', name: 'Utility Bill Year 1 (Before Install)' },
      { id: 'utility_bill_after_solar_year_0', name: 'Utility Bill Year 1 (After Install)' },
      { id: 'utility_bill_lifetime_before_solar', name: 'Lifetime Utility Bill (Before Install)' },
      { id: 'utility_bill_lifetime_after_solar', name: 'Lifetime Utility Bill (After Install)' },

      // Electricity bill & finance (utility account only; excludes gas/fuel)
      { id: 'electricity_utility_savings_total', name: 'Electricity Bill Savings (Lifetime)' },
      { id: 'electricity_utility_bill_savings_year_0', name: 'Electricity Bill Savings (Year 1)' },
      { id: 'electricity_utility_savings_per_bill_year_0', name: 'Electricity Bill Savings Per Bill' },
      { id: 'electricity_net_savings_year_0', name: 'First Year Savings (Electricity)' },
      { id: 'electricity_utility_bill_before_solar_year_0', name: 'Electricity Bill Year 1 (Before Solar)' },
      { id: 'electricity_utility_bill_after_solar_year_0', name: 'Electricity Bill Year 1 (After Solar)' },
      { id: 'electricity_utility_bill_lifetime_before_solar', name: 'Lifetime Electricity Bill (Before Solar)' },
      { id: 'electricity_utility_bill_lifetime_after_solar', name: 'Lifetime Electricity Bill (After Solar)' },
      { id: 'electricity_average_monthly_old_bill', name: 'Average Monthly Electricity Bill (Before Solar)' },
      { id: 'electricity_average_monthly_new_bill_year_1', name: 'Average Monthly Electricity Bill (After Solar)' },

      // Financial Metrics
      { id: 'electricity_net_present_value', name: 'Net Present Value (Electricity)' },
      { id: 'electricity_payback', name: 'Payback (Electricity)' },
      { id: 'electricity_discounted_payback_period', name: 'Discounted Payback (Electricity)' },
      { id: 'electricity_total_return_on_investment', name: 'Total Return on Investment (Electricity)' },
      { id: 'electricity_internal_rate_of_return', name: 'Rate of Return on Investment (Electricity)' },
      { id: 'payback', name: 'Payback' },
      { id: 'discounted_payback_period', name: 'Discounted Payback Period' },
      { id: 'net_present_value', name: 'Net Present Value' },
      { id: 'total_return_on_investment', name: 'Total Return on Investment' },
      { id: 'internal_rate_of_return', name: 'Rate of Return on Investment' },
      { id: 'lcoe', name: 'Levelized Cost of Energy' },
      { id: 'net_cost_us', name: 'Net Cost' },
      { id: 'lifetime_net_profit', name: 'Net Savings (Lifetime)' },

      // Cost to customer for installing Solar
      { id: 'system_price', name: 'Total System Price (Auto inc/ex tax)' },
      { id: 'system_price_inc_tax', name: 'Total System Price inc tax' },
      { id: 'system_price_ex_tax', name: 'Total System Price ex tax' },
      { id: 'purchase_price', name: 'Purchase Price (Auto inc/ex tax)' },
      { id: 'purchase_price_inc_tax', name: 'Purchase Price inc tax' },
      { id: 'purchase_price_ex_tax', name: 'Purchase Price ex tax' },
      { id: 'payment_amount', name: 'Payment Amount (Auto inc/ex tax)' },
      { id: 'payment_amount_inc_tax', name: 'Payment Amount inc tax' },
      { id: 'payment_amount_ex_tax', name: 'Payment Amount ex tax' },
      { id: 'net_system_price', name: 'Net System Price (Auto inc/ex tax)' },
      { id: 'net_system_price_inc_tax', name: 'Net System Price inc tax' },
      { id: 'net_system_price_ex_tax', name: 'Net System Price ex tax' },
      { id: 'net_payment_amount', name: 'Net Payment Amount (Auto inc/ex tax)' },
      { id: 'net_payment_amount_inc_tax', name: 'Net Payment Amount inc tax' },
      { id: 'net_payment_amount_ex_tax', name: 'Net Payment Amount ex tax' },
    ],
  },
]

const PROPOSAL_V2_HIDDEN_DISCLAIMER_FIELD_KEYS = ['disclaimer_daily_energy_flows', 'disclaimer_environmental_benefits']

export const ADVANCED_SETTINGS_FIELDS = [
  { type: 'h1', title: 'Advanced Settings' },
  { type: 'h2', title: 'Proposal Checkout Settings' },
  {
    type: 'p',
    title:
      'You can control whether your customers can checkout proposal or not. When disabled, new proposals can not be accepted by the customers.',
  },
  {
    fieldName: 'proposal_checkout_buttons',
    type: 'SelectInput',
    choices: [
      { id: 'disable_after_expiry', name: 'Disable after proposal validity has expired' },
      { id: 'enabled', name: 'Enabled' },
      { id: 'disabled', name: 'Disabled' },
    ],
  },
  {
    fieldName: 'proposal_checkout_message',
    type: 'DraftEditorWithContent',
    fieldLabel: 'Message to customer when proposal checkout is disabled',
    mentionContext: 'org_and_project_without_project_specific_terms',
    allowUploadImage: true,
    condition: 'proposal_checkout_buttons',
    conditionOperand: ['disable_after_expiry', 'disabled'],
  },
  { type: 'h2', title: 'Cumulative Bill Savings Chart Settings' },
  {
    type: 'p',
    title: 'When enabled, any export credit in the Cumulative Bill Savings chart is combined with the savings value.',
  },
  {
    fieldName: 'hide_export_credit_breakdown',
    fieldLabel: 'Hide Export Credit Breakdown',
    type: 'BooleanInput',
    defaultValue: false,
  },
  { type: 'h2', title: 'Net Financial Impact Chart Settings' },
  {
    type: 'p',
    title:
      'When locked, the Cumulative and Annual Savings chart follows the same minimum and maximum savings on the y-axis between all the system and payment options for better savings comparison.',
  },
  {
    fieldName: 'lock_y_axis_across_all_options',
    fieldLabel: 'Lock Minimum/Maximum Axis',
    type: 'BooleanInput',
    defaultValue: true,
  },
]

/** Org-level settings persisted on ProposalTemplate.settings (not proposal_v2_config.template_settings). */
export const PROPOSAL_V2_BESPOKE_DEFAULT_VALID_FOR_DAYS = 30

export const PROPOSAL_V2_BESPOKE_ORG_SETTINGS_FIELDS = [
  { type: 'h1', title: 'Proposal Settings' },
  {
    fieldName: 'valid_for_days',
    type: 'TextInput',
    fieldLabel: 'Default Proposal Validity (days)',
    defaultValue: PROPOSAL_V2_BESPOKE_DEFAULT_VALID_FOR_DAYS,
  },
]

export const PROPOSAL_V2_GRAPES_SWIPE_TEMPLATE_INPUTS_FIELDS = [
  { type: 'h1', title: 'Proposal Content' },
  { type: 'h2', title: 'Template Library Cards' },
  { fieldName: 'proposal_image_file_contents', type: 'ImageField', fieldLabel: 'Template Image' },
  { fieldName: 'proposal_image_file_contents', type: 'ImageInput' },
  ...FEATURE_FIGURES_FIELDS,
  ...DISCLAIMER_FIELDS.filter(
    (disclaimer) => !PROPOSAL_V2_HIDDEN_DISCLAIMER_FIELD_KEYS.includes(disclaimer.fieldName || '')
  ),
  ...ADVANCED_SETTINGS_FIELDS,
]

export const PROPOSAL_V2_PROJECT_LEVEL_FIELDS = [
  { type: 'h1', title: 'Proposal Content' },
  ...FEATURE_FIGURES_FIELDS,
  ...DISCLAIMER_FIELDS.filter(
    (disclaimer) => !PROPOSAL_V2_HIDDEN_DISCLAIMER_FIELD_KEYS.includes(disclaimer.fieldName || '')
  ),
  ...ADVANCED_SETTINGS_FIELDS,
]

export const PROPOSAL_TEMPLATE_INPUTS_FIELDS: any[] = [
  { type: 'h1', title: 'Proposal Settings' },

  { fieldName: 'valid_for_days', type: 'TextInput', fieldLabel: 'Default Proposal Validity (days)' },

  {
    fieldName: 'sections',
    fieldLabel: 'Sections',
    type: 'SectionConfiguration',
    choices: [
      {
        id: 'letter',
        label: 'Cover Message',
        defaultValue: true,
      },
      {
        id: 'about_us',
        label: 'About Us (PDF only)',
        defaultValue: true,
      },
      {
        id: 'systems_table',
        label: 'Systems Comparison Table (PDF only)',
        defaultValue: true,
      },
      {
        id: 'systems_group',
        label: 'Systems Group',
        defaultValue: true,
        children: [
          {
            id: 'feature_figures',
            label: 'Feature Figures',
            defaultValue: true,
          },
          {
            id: 'system_image',
            label: 'System Image',
            defaultValue: true,
          },
          {
            id: 'system_hardware',
            label: 'System Details',
            defaultValue: true,
          },
          {
            id: 'exhibit_tile_hardware',
            label: 'Hardware Showcase Tiles',
            defaultValue: true,
            children: [
              {
                id: 'exhibit_tile_module',
                label: 'Module Showcase Tile',

                defaultValue: true,
              },
              {
                id: 'exhibit_tile_inverter',
                label: 'Inverter Showcase Tile',
                defaultValue: true,
              },
              {
                id: 'exhibit_tile_battery',
                label: 'Battery Showcase Tile',
                defaultValue: true,
              },
              {
                id: 'exhibit_tile_other',
                label: 'Other Component Showcase Tile',
                defaultValue: true,
              },
            ],
          },
          {
            id: 'business_video_link',
            label: 'Business Video',
            defaultValue: false,
          },
          {
            id: 'energy_supply',
            label: 'System Performance',
            defaultValue: true,
          },
          {
            id: 'self_consumption_breakdown',
            label: 'Self-consumption and export limit breakdown',
            defaultValue: false,
          },
          {
            id: 'environmental_benefits',
            label: 'Environmental Benefits',
            defaultValue: true,
          },
          {
            id: 'how_your_system_works',
            label: 'How your system works',
            defaultValue: true,
          },
          {
            id: 'switch_energy_plan',
            label: 'Switch Energy Plan',
            defaultValue: true,
          },
          {
            id: 'daily_energy_flows',
            label: 'Daily energy flows',
            defaultValue: false,
          },
          {
            id: 'payment_options_group',
            label: 'Payment Options Group',
            defaultValue: true,
            children: [
              {
                id: 'bill_savings',
                label: 'Bill Savings',
                defaultValue: true,
                children: [
                  {
                    id: 'bill_savings_table',
                    label: 'Bill Savings Table',
                    defaultValue: true,
                  },
                ],
              },
              {
                id: 'exhibit_tile_utility_tariffs',
                label: 'Tariff Showcase Tile',
                defaultValue: true,
              },
              {
                id: 'financial_benefits',
                label: 'Financial Benefits',
                defaultValue: true,
                children: [
                  {
                    id: 'financial_benefits_detailed',
                    label: 'Financial Benefits Detailed',
                    defaultValue: false,
                  },
                ],
              },
              {
                id: 'payment_options',
                label: 'Quotation Table',
                defaultValue: true,
              },
              {
                id: 'exhibit_tile_finance',
                label: 'Finance Showcase Tile',
                defaultValue: true,
              },
            ],
          },
        ],
      },
      {
        id: 'next_steps',
        label: 'Next Steps',
        defaultValue: true,
      },
      {
        id: 'case_studies_simple',
        label: 'Case Studies',
        defaultValue: true,
      },
      {
        id: 'contract',
        label: 'Terms and Conditions',
        defaultValue: true,
      },
      {
        id: 'action_buttons',
        label: 'Action Buttons (Online only)',
        defaultValue: true,
      },
      {
        id: 'opensolar_disclaimer',
        label: 'OpenSolar Disclaimer (required)',
        defaultValue: true,
      },
      {
        id: 'spec_sheets',
        label: 'Brochures / Spec Sheets',
        defaultValue: true,
      },
      {
        id: 'content_block_1',
        label: 'Content Block 1',
        defaultValue: false,
      },
      {
        id: 'content_block_2',
        label: 'Content Block 2',
        defaultValue: false,
      },
      {
        id: 'content_block_3',
        label: 'Content Block 3',
        defaultValue: false,
      },
    ],
    genericGroup: ['content_block_1', 'content_block_2', 'content_block_3'],
    disabledChoices: ['opensolar_disclaimer'],
  },
  ...FEATURE_FIGURES_FIELDS,

  { type: 'h2', title: 'Business Video' },
  { fieldName: 'business_video_link', type: 'TextInput', fieldLabel: 'Youtube Video Link' },

  { type: 'h2', title: 'Showcase Settings' },

  {
    fieldName: 'exhibit_content',
    fieldLabel: 'Showcase Content',
    type: 'SelectInput',
    choices: [
      { id: 'yes', name: 'Yes' },
      { id: 'no', name: 'No' },
    ],
  },

  {
    fieldName: 'show_product_types',
    type: 'SelectArrayInput',
    choices: [
      { id: 'module', name: 'Module' },
      { id: 'inverter', name: 'Inverter' },
      { id: 'battery', name: 'Battery' },
      { id: 'other', name: 'Others' },
      { id: 'utility_tariff', name: 'Tariff' },
    ],
  },
  {
    fieldName: 'featured_product_types',
    fieldLabel: 'Is Featured (Staff only)',
    type: 'SelectArrayInput',
    staff_only: true,
    choices: [
      { id: 'module', name: 'Module' },
      { id: 'inverter', name: 'Inverter' },
      { id: 'battery', name: 'Battery' },
      { id: 'other', name: 'Other' },
      { id: 'utility_tariff', name: 'Tariff' },
    ],
  },

  { type: 'h1', title: 'PDF Content' },
  {
    fieldName: 'pdf_systems_to_include',
    type: 'SelectInput',
    choices: [
      { id: 'selected', name: 'Selected' },
      { id: 'all', name: 'All' },
    ],
  },
  {
    fieldName: 'pdf_payment_options_to_include',
    type: 'SelectInput',
    choices: [
      { id: 'selected', name: 'Selected' },
      { id: 'all', name: 'All' },
    ],
  },

  {
    fieldName: 'qr_code_toggle',
    fieldLabel: 'Add QR Code to access Online Proposal',
    type: 'BooleanInput',
  },
  {
    type: 'Alert',
    title:
      'QR Code to access Online Proposal is only shown in the proposal PDF if proposal shareability is enabled in Project > Info.',
  },
  {
    fieldName: 'qr_code_user_input',
    fieldLabel: 'QR Code Cover Page Content',
    type: 'DraftEditorWithContent',
    condition: 'qr_code_toggle',
    mentionContext: 'org_and_project_without_project_specific_terms',
    allowUploadImage: false,
    charCounterMax: 250,
  },

  { type: 'h1', title: 'Cover Page Template' },

  { fieldName: 'heading_cover', type: 'TextInput', fieldLabel: 'Cover Page Title' },

  { type: 'h2', title: 'Cover Page Image' },
  { fieldName: 'proposal_image_file_contents', type: 'ImageField', fieldLabel: 'Cover Page Image' },
  { fieldName: 'proposal_image_file_contents', type: 'ImageInput' },
  {
    fieldName: 'cover_image_format',
    fieldLabel: 'Cover Image Format',
    type: 'RadioButtonGroupInput',
    choices: [
      { id: 'half', name: 'Half' },
      { id: 'full', name: 'Full' },
    ],
  },

  { type: 'h2', title: 'Co-Branding Logo' },
  { fieldName: 'co_branding_logo_file_contents', type: 'ImageField', fieldLabel: 'Co-Branding Logo' },
  { fieldName: 'co_branding_logo_file_contents', type: 'ImageInput' },

  { type: 'h2', title: 'Cover Page Message' },
  {
    fieldName: 'letter_page_content',
    fieldLabel: 'Letter Page Content',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_without_project_specific_terms',
    allowUploadImage: false,
    charCounterMax: 2200,
    fieldLabelEndAdornment: {
      action: 'preview',
      adornment: 'icon',
      dialog_name: 'AboutUs',
      tooltips: 'Click to preview',
    },
  },
  { type: 'h2', title: 'Cover Page Headers' },
  {
    fieldName: 'header_column_1',
    fieldLabel: 'Header Column 1 of 3',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_without_project_specific_terms',
    allowUploadImage: true,
    charCounterMax: 250,
  },
  {
    fieldName: 'header_column_2',
    fieldLabel: 'Header Column 2 of 3',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_without_project_specific_terms',
    allowUploadImage: true,
    charCounterMax: 250,
  },
  {
    fieldName: 'header_column_3',
    fieldLabel: 'Header Column 3 of 3',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_without_project_specific_terms',
    allowUploadImage: true,
    charCounterMax: 250,
  },

  { type: 'h2', title: 'Cover Page Footers' },
  {
    fieldName: 'footer_column_1',
    fieldLabel: 'Footer Column 1 of 4',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_without_project_specific_terms',
    allowUploadImage: true,
    charCounterMax: 250,
  },
  {
    fieldName: 'footer_column_2',
    fieldLabel: 'Footer Column 2 of 4',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_without_project_specific_terms',
    allowUploadImage: true,
    charCounterMax: 250,
  },
  {
    fieldName: 'footer_column_3',
    fieldLabel: 'Footer Column 3 of 4',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_without_project_specific_terms',
    allowUploadImage: true,
    charCounterMax: 250,
  },
  {
    fieldName: 'footer_column_4',
    fieldLabel: 'Footer Column 4 of 4',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_without_project_specific_terms',
    allowUploadImage: true,
    charCounterMax: 250,
  },

  { type: 'h1', title: 'Standard Page Template' },

  { type: 'h2', title: 'Standard Page Footer' },
  {
    fieldName: 'footer_column_left',
    fieldLabel: 'Footer Column Left',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_without_project_specific_terms',
    allowUploadImage: false,
    charCounterMax: 250,
  },

  { type: 'h1', title: 'Proposal Content' },

  { type: 'h2', title: 'General Content' },
  {
    fieldName: 'about_us_content',
    fieldLabel: 'About Us',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_without_project_specific_terms',
    allowUploadImage: true,
    fieldLabelEndAdornment: {
      action: 'preview',
      adornment: 'icon',
      dialog_name: 'AboutUs',
      tooltips: 'Click to preview',
    },
  },
  {
    fieldName: 'hide_about_us_content_in_letter',
    fieldLabel: 'Hide About Us in Cover Message Dialog in MyEnergy',
    type: 'BooleanInput',
  },
  {
    fieldName: 'next_steps_content',
    fieldLabel: 'Next Steps',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_without_project_specific_terms',
    allowUploadImage: true,
    fieldLabelEndAdornment: {
      action: 'preview',
      adornment: 'icon',
      dialog_name: 'NextSteps',
      tooltips: 'Click to preview',
      disableWhenEmpty: true,
    },
  },
  {
    fieldName: 'quotation_custom_content',
    fieldLabel: 'Quotation Content',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_without_project_specific_terms',
    allowUploadImage: true,
  },

  {
    fieldName: 'content_block_1',
    fieldLabel: 'Content Block 1',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_without_project_specific_terms',
    allowUploadImage: true,
  },

  {
    fieldName: 'content_block_2',
    fieldLabel: 'Content Block 2',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_without_project_specific_terms',
    allowUploadImage: true,
  },

  {
    fieldName: 'content_block_3',
    fieldLabel: 'Content Block 3',
    type: 'DraftEditorWithContent',
    mentionContext: 'org_and_project_without_project_specific_terms',
    allowUploadImage: true,
  },
  { type: 'h2', title: 'Override Org Logo' },
  { type: 'p', title: 'Image uploaded here will be used instead of the org logo when this proposal template is used.' },
  { fieldName: 'override_logo_file_contents', type: 'ImageField', fieldLabel: 'Override Org Logo' },
  { fieldName: 'override_logo_file_contents', type: 'ImageInput' },

  { type: 'h2', title: 'Customise Headings' },
  {
    fieldName: 'heading_recommended_system_option',
    type: 'TextInput',
    fieldLabel: 'Heading - Recommended System Option',
  },
  { fieldName: 'heading_system_hardware', type: 'TextInput', fieldLabel: 'Heading - Your Solution' },
  { fieldName: 'heading_system_performance', type: 'TextInput', fieldLabel: 'Heading - System Performance' },
  {
    fieldName: 'heading_electricity_bill_savings',
    type: 'TextInput',
    fieldLabel: 'Heading - Energy Bill Savings',
  },
  { fieldName: 'heading_how_your_system_works', type: 'TextInput', fieldLabel: 'Heading - How Your System Works' },
  { fieldName: 'heading_daily_energy_flows', type: 'TextInput', fieldLabel: 'Heading - Daily Energy Flows' },
  { fieldName: 'heading_payment_option', type: 'TextInput', fieldLabel: 'Heading - Payment Option' },
  { fieldName: 'heading_net_financial_impact', type: 'TextInput', fieldLabel: 'Heading - Net Financial Impact' },
  { fieldName: 'heading_environmental_benefits', type: 'TextInput', fieldLabel: 'Heading - Environmental Benefits' },
  { fieldName: 'heading_case_studies', type: 'TextInput', fieldLabel: 'Heading - Case Study' },
  { fieldName: 'heading_next_steps', type: 'TextInput', fieldLabel: 'Heading - Next Steps' },
  ...DISCLAIMER_FIELDS,
  ...ADVANCED_SETTINGS_FIELDS,
]

// Add after others so we can use other fields to lookup their labels
// Insert into index=3, right after "sections"
PROPOSAL_TEMPLATE_INPUTS_FIELDS.push({
  type: 'h1',
  title: 'Locked Sections',
  visibility: function (record, enableExhibit) {
    if (record.original || !enableExhibit) {
      return false
    } else {
      return true
    }
  },
})
PROPOSAL_TEMPLATE_INPUTS_FIELDS.push({
  fieldName: 'locked_sections',
  fieldLabel: 'Locked Sections',
  type: 'CustomCheckboxGroupInput',
  choices: getLockedSectionsChoices(),
  visibility: function (record, enableExhibit) {
    if (record.original || !enableExhibit) {
      return false
    } else {
      return true
    }
  },
})
